import React, { PureComponent, Fragment } from 'react'
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Radio
} from '@material-ui/core'

export class PaidStatus extends PureComponent {
  state = {
    status: null
  }

  onChange = e => {
    const { target: { value } } = e

    this.setState({
      status: value
    })
  }

  render() {
    const { status } = this.state
    const { onSubmit, onClose } = this.props

    return (
      <Fragment>

        <DialogTitle>Оберіть статус бронювання</DialogTitle>

        <Divider />

        <DialogContent>
          <List>

            <ListItem>
              <ListItemText
                primary='Оплачено'
                secondary='Замовлення оплачене під час бронювання квитка'
              />
              <ListItemSecondaryAction>
                <Radio
                  onChange={this.onChange}
                  checked={status === 'paid'}
                  value='paid'
                  name='paid'
                />
              </ListItemSecondaryAction>
            </ListItem>

            <ListItem>
              <ListItemText
                primary='Бронь'
                secondary='Оплата здійснюється під час посадки до автобуса'
              />
              <ListItemSecondaryAction>
                <Radio
                  onChange={this.onChange}
                  checked={status === 'book'}
                  value='book'
                  name='book'
                />
              </ListItemSecondaryAction>
            </ListItem>

            <ListItem>
              <ListItemText
                primary='Доплата'
                secondary='Під час бронювання квитка внесений аванс, доплата здійснюється під час посадки до автобуса'
              />
              <ListItemSecondaryAction>
                <Radio
                  onChange={this.onChange}
                  checked={status === 'surcharge'}
                  value='surcharge'
                  name='surcharge'
                />
              </ListItemSecondaryAction>
            </ListItem>

          </List>
        </DialogContent>

        <DialogActions>
          <Button color='primary' onClick={onClose}>
            Скасувати
          </Button>
          <Button color='primary' onClick={onSubmit(status)}>
            Забронювати
          </Button>
        </DialogActions>

      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PaidStatus/PaidStatus.js